interface MerchantLimitListLoader {
    "receiver_merchant_limit_new": number | null,
    "receiver_term": string,
    "receiver_id": number,
    "receiver_active_merchant_limit": boolean,
    "product_limit": ProductLimit[]
}

interface ProductLimit {
    "name": string,
    "amount": number,
    "id": number,
    "term": number,
    "type": number
}

interface Notification {
    "class": string,
    "message": string
}

const TERMS: any = {
    0: 'month',
    1: 'quarter',
    2: 'year'
};

const TYPE: any = {
    0: 'in',
    1: 'out'
};

export {type MerchantLimitListLoader, type ProductLimit, type Notification, TERMS, TYPE};